function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Pressable } from 'react-native';
import styled from 'styled-components/native';
import { useHover, useActive } from 'react-native-web-hooks';
import useMobile from '../hooks/use-mobile';
import Text from '../text';
import Colors from '../colors';
const colors = {
  back: {
    text: Colors.mint500,
    default: Colors.transparent,
    hovered: Colors.lightGray200,
    active: Colors.lightGray300
  },
  next: {
    text: Colors.white,
    default: Colors.mint400,
    hovered: Colors.mint500,
    active: Colors.mint600
  }
};
const StyledContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${props => props.mobile ? 16 : 32}px;
  padding-top: ${props => props.mobile ? 40 : 56}px;
  padding-bottom: 32px;
`;

const StyledButton = button => {
  const ref = useRef();
  const isHovered = useHover(ref);
  const isActive = useActive(ref);
  const styles = {
    default: {
      backgroundColor: colors[button.type].default,
      paddingVertical: 7,
      paddingLeft: button.mobile ? 32 : 33,
      paddingRight: button.mobile ? 30 : 32,
      borderRadius: 100
    },
    hovered: {
      backgroundColor: colors[button.type].hovered
    },
    active: {
      backgroundColor: colors[button.type].active
    },
    disabled: {
      opacity: 0.4,
      cursor: 'default'
    }
  };
  return /*#__PURE__*/React.createElement(Pressable, {
    ref: ref,
    onPress: button.onPress,
    disabled: button.disabled
  }, /*#__PURE__*/React.createElement(Text.BodyBase, {
    style: [styles.default, isHovered && !button.disabled && styles.hovered, isActive && !button.disabled && styles.active, button.disabled && styles.disabled],
    weight: "regular",
    color: colors[button.type].text
  }, button.label));
};

export default function Footer(props) {
  const mobile = useMobile();
  return /*#__PURE__*/React.createElement(StyledContainer, {
    mobile: mobile,
    style: props.style
  }, /*#__PURE__*/React.createElement(StyledButton, _extends({
    type: "back",
    mobile: mobile
  }, props.back)), /*#__PURE__*/React.createElement(StyledButton, _extends({
    type: "next",
    mobile: mobile
  }, props.next)));
}
Footer.defaultProps = {
  style: null,
  back: {
    label: 'Back',
    onPress: () => {},
    disabled: false
  },
  next: {
    label: 'Save and Continue',
    onPress: () => {},
    disabled: false
  }
};
Footer.propTypes = {
  style: PropTypes.object,
  back: PropTypes.shape({
    label: PropTypes.string,
    onPress: PropTypes.func,
    disabled: PropTypes.bool
  }),
  next: PropTypes.shape({
    label: PropTypes.string,
    onPress: PropTypes.func,
    disabled: PropTypes.bool
  })
};
//# sourceMappingURL=footer.js.map